import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import AvulsoSuccessView from "./view";
import useTicket from "@/hooks/useTicket";
import useMundialeChat from "@/hooks/useMundialeChat";
import { useScrapersConsultation } from "@/hooks/useScrapersConsultation";
import { ReducersTypes } from "@/redux/reducers/Models";
import { getAvulsoSuccessHomeUrl } from "../getCheckoutSuccessPath";

export default function AvulsoSuccess() {
  useMundialeChat();
  const navigate = useNavigate();
  const user = useSelector((state: ReducersTypes) => state.userReducer);
  const plate = user?.plate || "";

  const {
    isLoading,
    openPaymentReceipt,
    generatePDF,
    invoice,
    toggleModal,
    isVisibleModal,
    errorTickets,
    errorInvoice,
  } = useTicket();

  const { consultation } = useScrapersConsultation(plate, {
    enabled: Boolean(plate),
    reuseCache: true,
  });

  const openInvoice = () => {
    openPaymentReceipt();
  };

  const goToPlateSearch = () => {
    window.location.assign(getAvulsoSuccessHomeUrl());
  };

  return (
    <AvulsoSuccessView
      goBack={goToPlateSearch}
      onNotNow={goToPlateSearch}
      openInvoice={openInvoice}
      consultation={plate ? consultation : undefined}
      invoice={invoice}
      toggleModal={toggleModal}
      generatePDF={generatePDF}
      isVisibleModal={isVisibleModal}
      isLoading={isLoading}
      error={errorTickets || errorInvoice}
      toggleError={toggleModal}
      toggleModalRegister={() => navigate("/register")}
      handleTryAgain={() => {
        toggleModal();
        openInvoice();
      }}
    />
  );
}
